import React, { useState } from "react";
import Modal from "../componentLibrary/Modal";
import Textarea from "../componentLibrary/Textarea";
import Button from "../componentLibrary/Button";

interface ErrorReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (description: string) => void;
}

const ErrorReportModal: React.FC<ErrorReportModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSubmit(description);
      setDescription("");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setDescription("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onCloseModal={handleClose}
      title="Error Report"
      size="md"
      height="auto"
      maxHeight="80vh"
      footer={
        <div className="flex gap-2 justify-end">
          <Button variant="secondary" onClick={handleClose}>
            Skip
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </div>
      }
    >
      <div className="space-y-4 py-4">
        <div className="text-sm text-gray-600">
          <p className="mb-2">
            An error has been automatically reported to help us improve the
            application.
          </p>
        </div>

        <div>
          <Textarea
            label="Can you describe what you were trying to do? (Optional)"
            placeholder="Please describe what happened before the error occurred..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            convertPlaceholder={false}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ErrorReportModal;
